/**
 * MechaGuard - TowerPanel (选中防御塔信息面板)
 *
 * 对应规划中的 UpgradePanel：显示选中塔的数值，并提供升级 / 出售操作。
 * 面板整体在 DOM 中构建一次，后续只更新文本与禁用状态。
 */

export class TowerPanel {
  constructor() {
    /** @type {import('../entities/Tower.js').Tower|null} */
    this.tower = null;
    this._gold = 0;
    this._els = {};
    this._handlers = {};
    this._root = null;
  }

  /**
   * @param {{onUpgrade?:Function,onSell?:Function,onClose?:Function}} handlers
   */
  init(handlers = {}) {
    this._handlers = handlers;

    const root = document.getElementById('tower-panel');
    if (!root) return;
    this._root = root;
    root.innerHTML = '';

    // ---- 标题行 ----
    const head = document.createElement('div');
    head.className = 'tp-head';

    const title = document.createElement('div');
    title.className = 'tp-title';

    const icon = document.createElement('span');
    icon.className = 'tp-icon';

    const name = document.createElement('span');

    const level = document.createElement('span');
    level.className = 'tp-level';

    title.append(icon, name, level);

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'tp-close';
    close.textContent = '✕';
    close.title = '关闭';
    close.addEventListener('click', () => this._handlers.onClose?.());

    head.append(title, close);

    // ---- 数值区 ----
    const stats = document.createElement('div');
    stats.className = 'tp-stats';

    // ---- 操作区 ----
    const actions = document.createElement('div');
    actions.className = 'tp-actions';

    const upgradeBtn = document.createElement('button');
    upgradeBtn.type = 'button';
    upgradeBtn.className = 'tp-btn tp-btn--upgrade';
    upgradeBtn.addEventListener('click', () => this._handlers.onUpgrade?.());

    const sellBtn = document.createElement('button');
    sellBtn.type = 'button';
    sellBtn.className = 'tp-btn tp-btn--sell';
    sellBtn.addEventListener('click', () => this._handlers.onSell?.());

    actions.append(upgradeBtn, sellBtn);

    root.append(head, stats, actions);

    this._els = { icon, name, level, stats, upgradeBtn, sellBtn };
  }

  /** 显示某座塔 */
  show(tower) {
    if (!this._root) return;
    this.tower = tower;
    this._render();
    this._root.classList.remove('hidden');
  }

  /** 隐藏面板 */
  hide() {
    this.tower = null;
    if (this._root) this._root.classList.add('hidden');
  }

  /** 同步金币（用于按钮可用状态） */
  setGold(gold) {
    this._gold = gold;
    if (this.tower) this._updateButtons();
  }

  /* ===================================================
   * 内部渲染
   * =================================================== */

  _render() {
    const t = this.tower;
    if (!t || !this._els.name) return;

    this._els.icon.textContent = t.meta.icon;
    this._els.name.textContent = t.name;
    this._els.level.textContent = `Lv.${t.level}/${t.maxLevel}`;

    const stats = this._els.stats;
    stats.innerHTML = '';
    stats.append(
      this._statRow('伤害', t.damage.toFixed(1)),
      this._statRow('射程', String(Math.round(t.range))),
      this._statRow('每秒伤害', t.dps.toFixed(1)),
      this._statRow('累计伤害', String(Math.round(t.totalDamage))),
    );

    this._updateButtons();
  }

  _updateButtons() {
    const t = this.tower;
    const up = this._els.upgradeBtn;
    const sell = this._els.sellBtn;
    if (!t || !up || !sell) return;

    if (t.canUpgrade()) {
      const cost = t.getUpgradeCost();
      up.textContent = `升级 Lv.${t.level + 1} · ${cost}G`;
      up.disabled = this._gold < cost;
    } else {
      up.textContent = '已满级';
      up.disabled = true;
    }

    sell.textContent = `出售 +${t.getSellValue()}G`;
    sell.disabled = false;
  }

  _statRow(label, value) {
    const row = document.createElement('div');
    row.className = 'tp-stat';

    const l = document.createElement('span');
    l.className = 'tp-stat-label';
    l.textContent = label;

    const v = document.createElement('span');
    v.className = 'tp-stat-value';
    v.textContent = value;

    row.append(l, v);
    return row;
  }
}
